export default "__VITE_ASSET__UtOf7$87__"